import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeUIProvider } from 'theme-ui';
import { onAuthStateChanged } from 'firebase/auth';
import { UserProfileProvider } from './userProfileContext';

import Navbar from "./Navbar";
import Login from "./Login";
import Directory from "./Directory";
import Profile from "./Profile";
import Events from "./Events.js";
import Resources from "./Resources";
import UserProfilePage from "./UserProfilePage.js";
import Comp from "./Comp.js";
import theme from './theme';

// test

// Import pre-initialized auth instance
import { auth } from './config/firebaseConfig.js';

const DefaultContainer = ({ loggedIn, setLoggedIn }) => {
  return (
    <>
      {!loggedIn && <Login loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>}
      {loggedIn && <Navbar props={loggedIn} />}
        <div style={{ paddingLeft: loggedIn ? '20%' : '0' }}>
          <Routes>
            <Route path="/" element={loggedIn ? <Navigate to="/Events" /> : <Navigate to="/Login"/>} />
            {/* <Route path="/Login" element={<Login loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>} /> */}
            {loggedIn && <Route path="/Events" element={<Events/>}/>}
            <Route path="/Directory" element={loggedIn && <Directory/>}/>
            <Route path='/Resources' element={loggedIn && <Resources/>}/>
            <Route path="/Comp" element={loggedIn && <Comp />} /> 
            <Route path="/Profile" element={loggedIn && <Profile/>}/>
            <Route path="/Profile/:id" element={<UserProfilePage />} /> 
            <Route path="*" element={loggedIn && <div>404 Not Found</div>} />
          </Routes>
        </div>
    </>
  );
}


const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoggedIn(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <UserProfileProvider>
    <ThemeUIProvider theme={theme}>
      <Router>
        <div>
          <Routes>
            <Route path="/*" element={<DefaultContainer loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>} />
          </Routes>
        </div>
      </Router>
    </ThemeUIProvider>
    </UserProfileProvider>
  );
};

export default App;